import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Button } from "semantic-ui-react";
import Sidebar from "../../app/common/util/Sidebar";
import { connect } from "react-redux";
import NavBar from "../nav/NavBar/NavBar";
import OrderForm from "./OrderForm";
import { fetchFormData, validatefromHome } from "./orderActions";
import LoaderComponent from "../../app/common/util/LoaderComponent";
import { doesFormDataExist } from "./formUtils";
import { isEmpty } from "../../app/common/util/genericUtils";
import { Row, Col } from "antd";
import OrderMetaSummaryCard from "../home/orderDetails/OrderMetaSummaryCard";

class ValidationFromHomePage extends Component {
  state = {};
  componentWillMount() {
    const {
      match: { params },
      orderDetails,
      validatefromHome
    } = this.props;
    const dataFlag = doesFormDataExist();
    dataFlag && this.props.fetchFormData();
    if (isEmpty(orderDetails)) {
      validatefromHome(params.id);
    }
  }
  render() {
    const { orderDetails, loadingFormData } = this.props;
    if (loadingFormData === true || isEmpty(orderDetails)) {
      return <LoaderComponent />;
    }

    return (
      <div>
        <Sidebar />
        <div style={{ margin: "5% 10% 0 10%" }}>
          <Row gutter={16} type="flex" align="top">
            <Col xs={24} sm={12} md={12} lg={12}>
              <Button as={Link} to="/" icon labelPosition="left">
                <Icon name="left arrow" />
                Back to Orders
              </Button>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={12}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: 12,
                paddingBottom: 12,
              }}
            >
              <OrderMetaSummaryCard
                source={orderDetails.source}
                author={orderDetails.author}
                authorisedBy={orderDetails.authorised_by}
              />
            </Col>
          </Row>
        </div>
        <OrderForm
          initialValues={orderDetails}
          type="validateFromHome"
          labelInValue={true}
        />
        <NavBar />
      </div>
    );
  }
}
const actions = {
  fetchFormData,
  validatefromHome
};
const mapStateToProps = state => ({
  loadingFormData: state.orderForm.loadingOrderFromReferenceId,
  orderDetails: state.orderForm.orderDetailsFromReferenceId
});

export default connect(
  mapStateToProps,
  actions
)(ValidationFromHomePage);
